import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  withRouter
} from "react-router-dom";

// import './App.css';
// import Heading from './heading.js';
import Recipe from './recipe.js';
import recipes from './recipes.json';
import styled from 'styled-components';


const ContentStyle = styled.div`
  /* margin: 10px; */
  max-width: 200;
`;

function Content({location}) {
    console.log(location)
  return (
      <ContentStyle>
      <div>
        { location.pathname === "/" && <Nav />}
        <Switch>
          <Route path="/sorbet">
            <Sorbet />
          </Route>
          <Route path="/ramen_carbonara">
            <Ramen_carbonara />
          </Route>
          <Route path="/Miso_eggplant">
            <Miso_eggplant />
          </Route>
          <Route path="/Gomae">
            <Gomae />
          </Route>
          <Route path="/chocolate_chip_cookies">
            <Chocolate_chip_cookies />
          </Route>
          <Route path="/lasagna">
            <Lasagna />
          </Route>
          <Route path="/sheet_pan_pasta">
            <Sheet_pan_pasta />
          </Route>
          <Route path="/turkey_burgers">
            <Turkey_burgers />
          </Route>
        </Switch>
      </div>
      </ContentStyle>
  );
}

function Nav() {
    return(
        <div>
            <ul>
                {/* <Heading
                    title="savory"
                /> */}

                <li style={{padding: 10, listStyleType: "none"}}>
                    savory
                </li>

                <li>
                    <Link to="/ramen_carbonara">ramen carbonara</Link>
                </li>
                <li>
                    <Link to="/gomae">gomae</Link>
                </li>
                <li>
                    <Link to="/miso_eggplant">miso eggplant</Link>
                </li>
                <li>
                    <Link to="/lasagna">lasagna</Link>
                </li>
                <li>
                    <Link to="/sheet_pan_pasta">sheet pan pasta</Link>
                </li>
                <li>
                    <Link to="/turkey_burgers">turkey burgers</Link>
                </li>

                {/* <Heading
                    title="sweet"
                /> */}

                <li style={{padding: 10, listStyleType: "none"}}>
                    sweet
                </li>

                <li>
                    <Link to="/sorbet">sorbet</Link>
                </li>
                <li>
                    <Link to="/chocolate_chip_cookies">chocolate chip cookies</Link>
                </li>

            </ul>
        </div>
    );
}

function Miso_eggplant() {
    return (
      <div>
        <Recipe 
          recipe={recipes.miso_eggplant}
        />
      </div>
    );
  }

function Sorbet() {
  return (
    <div>
      <Recipe 
        recipe={recipes.sorbet}
      />
    </div>
  );
}

function Ramen_carbonara() {
  return (
    <div>
      <Recipe 
        recipe={recipes.ramen_carbonara}
      />
    </div>
  );
}

function Chocolate_chip_cookies() {
  return (
    <div>
      <Recipe 
        recipe={recipes.chocolate_chip_cookies}
      />
    </div>
  );
}

function Gomae() {
    return (
      <div>
        <Recipe 
          recipe={recipes.gomae}
        />
      </div>
    );
  }

function Lasagna() {
        return (
            <div>
            <Recipe
                recipe={recipes.lasagna}
            />
            </div>
        );
    }

function Sheet_pan_pasta() {
        return (
        <div>
            <Recipe 
                recipe={recipes.sheet_pan_pasta}
            />
        </div>
        );
    }

function Turkey_burgers() {
        return (
        <div>
            <Recipe 
                recipe={recipes.turkey_burgers}
            />
        </div>
        );
    }

export default withRouter(Content);